import { Tabs as TabsMui } from '@mui/material';
import React from 'react';
import { ITabs } from './interfaces';

export const Tabs: React.FC<ITabs> = ({
  activeTab = 1,
  children,
  onChange,
}): JSX.Element => {
  return (
    <TabsMui
      value={activeTab}
      onChange={(event, value) => onChange(value)}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={{
        minHeight: '20px',
        width: '100%',
        '.MuiTabs-indicator': {
          height: '3px',
        },
        '.MuiTab-root': {
          flexShrink: 0,
        },
      }}
    >
      {children}
    </TabsMui>
  );
};
